import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ewdoieuq6: FaireProductEntity = {
  token: "p_3ewdoieuq6",
  type: "product",
  name: "Helium 70 Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4c0ca805db0b223dcbdbd7f62c7d7c335ea33c6b9c7b842b5358cc1d0175bd2b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9874782436cef029f29b9f339a318b35419f824ee0636a623d83c9187826eaa.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:19.605Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
